/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/grid.css'
import './styles.scss'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { ScrollyTellingCover } from 'components/scrollytellingCover'
import { ArticleTeaser } from '../articleLink'
import { Link } from '@ta-interaktiv/contentbricks'

// TODO Set the correct article ID here
const ARTICLE_ID = '873240476197'
const darkMode =
  window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
const isMobile = window.innerWidth < 768

export function AppComponent() {
  return (
    <div className='index'>
      <Masthead inverted={darkMode} articleId={ARTICLE_ID} />
      <ThemeSwitch />

      <header className='ui vertical  very fitted  segment'>
        <div className='ui container'>
          <div className='ui header'>
            <div className='top-line'>Virage écologique raté?</div>
            <h1>Les avions volent presque autant qu’avant la pandémie</h1>
            <h2>
              Le nombre de décollages et d’atterrissages à Genève s’approche du
              niveau d’avant la crise sanitaire. Samedi, environ 50’000
              personnes y ont pris l’avion.
            </h2>
          </div>
        </div>
      </header>

      <ScrollyTellingCover />
      <div className='ui text container'>
        <div className='source'>
          Seule la première escale est indiquée. Si un passager se rend aux
          Etats-Unis via Francfort, le trajet Genève-Francfort sera le seul à
          apparaître. SOURCE: FlightRadar24
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui ta text container'>
          <div className='ta metainfo'>
            <div className='ta author'>
              Titus Plattner, Paul Ronga et Mathieu Rudaz
            </div>
            <div className='ta updated'>Mis à jour le 14 avril 2022</div>
          </div>
          <div className='ta text'>
            <p>
              Genève Aéroport connaît une forte fréquentation ce week-end de
              Pâques. On y attendait près de 48’000 passagers et passagères
              vendredi, 50’000 samedi et encore 50’000 ce dimanche, selon le
              porte-parole de l’aéroport Ignace Jeannerat. «C’est 80 à 85% du
              trafic de 2019 à la même période», précise-t-il. Vendredi et
              samedi, les six vols Easyjet vers Lisbonne et les trois vols vers
              Madrid affichaient complet, alors qu’il ne restait plus que
              quelques rares places sur certains vols pour Barcelone, Paris ou
              Naples.
            </p>
            <p>
              Ce week-end de très forte affluence s’inscrit dans le contexte
              d’une nette reprise des activités de l’aéroport amorcée ces
              derniers mois. C’est ce que confirme notre analyse de données de
              la société Flightradar24, qui nous a fourni la liste de vols de
              tous les décollages et atterrissages à Genève de ces deux
              dernières années. En mars, le site a enregistré 12'990 mouvements
              à Cointrin, le records de ces deux dernières années.
            </p>
            <p>
              L’espoir d’une prise de conscience écologique suite à la pandémie,
              avec de plus en plus de personnes prêtes à renoncer à prendre
              l’avion, semble douché. Quant aux riverains de l’aéroport qui ont
              goûté à des journées presque sans avions en 2020, ils ont dû
              supporter entre 360 et 380 mouvements par jour ce week-end de
              Pâques, soit un vol toutes les deux à trois minutes pendant la
              journée.
            </p>
          </div>
        </div>

        <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
          <div className='ui text container'>
            <ArticleTeaser ids={['327555721820']} inverted={darkMode} />
          </div>
        </div>

        <div className='ui vertical segment'>
          <div className='ui ta text container'>
            <p>
              L’Airports Council International, la faîtière européenne, situe le
              retour à la normale du nombre de passagers en 2024 selon un
              scénario prudent et à la fin de 2023 selon un scénario optimiste.
              Selon les dernières données disponibles, l’aéroport de Genève
              semble plutôt bien se remettre en comparaison européenne. Mais
              attention, ces prévisions ne tiennent compte ni de la guerre en
              Ukraine, ni de la hausse des cours du pétrole, qui devrait
              renchérir le prix des tickets d’avion dès cet été.
            </p>
          </div>
        </div>
        <div
          className='ui container'
          style={{ marginTop: '1.5em', marginBottom: '1em' }}
        >
          <div className='ui two columns stackable grid'>
            <div className='column'>
              <AutofitIFrame
                style={{ height: isMobile ? '600px' : '500px' }}
                src='https://datawrapper.dwcdn.net/Pb9OS/'
              />
            </div>
            <div className='column'>
              <AutofitIFrame
                style={{ height: isMobile ? '600px' : '500px' }}
                src='https://datawrapper.dwcdn.net/YHa8N/'
              />
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4>«On n’a rien appris»</h4>
            <p>
              Pour la CARPE, le regroupement d’associations à l’origine de
              l’initiative «Pour un pilotage démocratique de l’aéroport de
              Genève» qui vise à limiter sa croissance, ces ambitions de
              progression sont décevantes. «Il est absurde de vouloir maintenir
              la même offre quand il n’y a plus la même demande, avec un bilan
              climatique et des nuisances dramatiques», estime la Verte Lisa
              Mazzone, sa présidente.
            </p>
            <p>
              «On n’a rien appris: les compagnies aériennes et les aéroports
              cherchent à tout prix à revenir à la situation d’avant, bien
              qu’elle soit très lourde pour le climat et les riverains, relève
              la conseillère aux États. Le politique doit reprendre la main pour
              nous permettre de préserver notre planète.»
            </p>
            <p>
              Du côté du public, Nathalie Fabry, professeure à l’Université
              Gustave Eiffel, près de Paris, et spécialiste du tourisme, observe
              tout de même une prise de conscience: «On est dans un vrai
              changement de paradigme. Certaines personnes veulent revenir au
              tourisme d’avant, un tourisme de masse, mais d’autres sautent à
              pieds joints dans ce qu’ils espèrent devenir le tourisme d’après,
              un tourisme plus local et durable. Les contours de ce tourisme
              d’après ne sont pas encore bien définis.»
            </p>
            <p>
              En tout cas, la crise sanitaire a rebattu les cartes des
              destinations. Les vols vers les pays méditerranéens ont été plus
              nombreux durant l’été 2021 que durant l’été 2019. Sylvain Zeghni,
              maître de conférences en économie à l’Université Gustave Eiffel,
              observe un renversement: «Les pays du Sud, qu’on a tendance à
              catégoriser comme négligents, sont sortis plus vite de la pandémie
              que les pays du Nord. Leur image touristique s’est améliorée.»
            </p>
            <p>
              Du côté du nord, les destinations britanniques sont celles qui ont
              le plus souffert de la pandémie. En temps normal, Londres est
              largement en tête des destinations: ses aéroports concentrent
              presque 20% du trafic au départ de Genève. Six fois moins de vols
              ont desservi les destinations britanniques en juillet et août 2021
              que durant les mêmes mois en 2019.
            </p>
          </div>
        </div>

        <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
          <div className='ui container'>
            <div className='ui center aligned two column stackable grid'>
              <div className='column'>
                <div className='chart-title'>
                  Les destinations vers les 10 pays dont le nombre de vols a le
                  plus augmenté
                </div>
                <div className='chart-header'>
                  Augmentation des vols entre l'été 2019 et 2021
                </div>
                <div className='chart-text more'>
                  de <b className='special'>+270%</b> (Chypre) à{' '}
                  <b className='special'>+4%</b> (Tunisie)
                </div>
                <div className='mini-map-container'>
                  <div
                    className='map-label'
                    style={{
                      position: 'absolute',
                      left: '39%',
                      top: '30%',
                      width: '160px',
                      marginLeft: '-160px',
                      textAlign: 'right'
                    }}
                  >
                    Genève
                  </div>
                  <img
                    style={{ width: '100%' }}
                    src={require(`../../images/globe-commercial-more${
                      darkMode ? '-dark' : ''
                    }.png`)}
                  />
                </div>
              </div>
              <div className='column'>
                <div className='chart-title'>
                  Les destinations vers les 10 pays dont le nombre de vols a le
                  plus diminué
                </div>
                <div className='chart-header'>
                  Diminution des vols entre l'été 2019 et 2021
                </div>
                <div className='chart-text less'>
                  de <b className='special less'>-99%</b> (Chine) à{' '}
                  <b className='special less'>-72%</b> (Canada)
                </div>
                <div className='mini-map-container'>
                  <div
                    className='map-label'
                    style={{
                      position: 'absolute',
                      left: '72%',
                      top: '47%',
                      width: '160px',
                      textAlign: 'left'
                    }}
                  >
                    Genève
                  </div>
                  <img
                    style={{ width: '100%' }}
                    src={require(`../../images/globe-commercial-less${
                      darkMode ? '-dark' : ''
                    }.png`)}
                  />
                </div>
              </div>
            </div>
            <div className='ui text container'>
              <AutofitIFrame src='https://datawrapper.dwcdn.net/jLz7P/' />
              {/* <div className='source'>
                Seules les destinations avec un total de plus de 20 vols sur les
                années 2019 à 2021 ont été conservées. SOURCE: FlightRadar24
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ paddingTop: 0 }}>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Olivier Emch, président du Groupement des agences de voyages de
              Genève et patron de l’agence Executive Travel SA, est partagé
              entre l’optimisme et la retenue. «Beaucoup de clients souhaitent
              voyager, nous sommes très positifs, la reprise est là. Mais on
              reste loin du niveau d’avant la crise.»
            </p>
            <p>
              Et l’industrie du voyage et du tourisme a énormément pâti de la
              crise. Dans le monde, 62 millions de personnes travaillant dans ce
              secteur ont perdu leur emploi en 2020, selon le World Travel &
              Tourism Council. Soit un cinquième des 334 millions d’employés que
              comptait cette industrie en 2019.
            </p>
            <p>
              «Cela se ressent aujourd’hui dans la qualité du service, note
              Olivier Emch. Ce manque de personnel est le principal problème
              pour gérer la sortie de crise actuelle.»
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <hr />
          <div className='ta text'>
            <h4>Moitié moins de voyages d’affaires</h4>
            <p>
              Le secteur qui s’est affaissé le plus durablement est celui des
              déplacements professionnels. Il représente 70% des activités
              d’Executive Travel. Le voyagiste estime que le volume des voyages
              d’affaires reste inférieur de moitié à celui d’avant la crise
              tandis que l’organisation de vacances pour des particuliers
              atteint environ 80% du niveau d’avant-crise.
            </p>
            <p>
              Adrien Genier, directeur de Genève Tourisme, dresse un constat
              similaire: «On sait que les voyages d’affaires n’auront plus la
              même importance qu’auparavant. Les budgets que leur allouent les
              grandes entreprises ont diminué de moitié. Ce sont surtout les
              formations et les petits séminaires qui pâtissent de cette
              évolution.»
            </p>
            <p>
              Cette baisse met en péril tout un écosystème qui repose sur les
              marges importantes de ce secteur. «Les petits séminaires
              remplissaient considérablement les premières classes des trains,
              les avions et les hôtels. La généralisation des visioconférences
              affecte ces acteurs en chaîne», précise Nathalie Fabry,
              spécialiste du tourisme.
            </p>
            <p>
              Genève Tourisme mise depuis des années sur le tourisme interne,
              pour la simple raison que c’est le plus profitable. Reste à voir
              si ce changement de mentalité, précipité par la crise sanitaire,
              sera durable.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
        <div className='ui text container'>
          <div className='ta text'>
            <h4>
              Avec le Covid, le nombre de vols en jets privés a bondi de 20% à
              Genève
            </h4>
            <p>
              Un seul secteur a progressé durant la pandémie: l’aviation
              d’affaires, autrement dit les vols privés à la demande. Après une
              année 2020 morose, les compagnies proposant ce service ont
              enregistré une augmentation de leurs passagers de 2,8% en 2021 par
              rapport à 2019, selon Genève Aéroport.
            </p>
            <p>
              D’après notre analyse des données de Flightradar24, le nombre de
              vols effectués par des jets privés – en location ou non – était
              20% plus élevé en 2021 qu’en 2019. La forte baisse de 2020 (-17%)
              n’a pas duré. Dès que les interdictions de voyage ont été levées,
              cette clientèle très aisée s’est remise à voyager en avion.
            </p>
          </div>
        </div>

        <div className='ui vertical segment' style={{ paddingBottom: 0 }}>
          <div className='ui container'>
            <div className='ui center aligned two column stackable grid'>
              <div className='column'>
                <div className='chart-title'>
                  Les destinations vers les 10 pays dont le nombre de vols a le
                  plus augmenté{' '}
                </div>
                <div className='chart-header'>
                  Augmentation des vols en jets privés entre l'été 2019 et 2021
                </div>
                <div className='chart-text more'>
                  de <b className='special more'>+1170%</b> (Émirats arabes
                  unis) à <b className='special more'>+108%</b> (Pays-Bas)
                </div>
                <div className='mini-map-container'>
                  <div
                    className='map-label'
                    style={{
                      position: 'absolute',
                      left: '32%',
                      top: '28%',
                      width: '160px',
                      marginLeft: '-160px',
                      textAlign: 'right'
                    }}
                  >
                    Genève
                  </div>
                  <img
                    style={{ width: '100%' }}
                    src={require(`../../images/globe-jets-more${
                      darkMode ? '-dark' : ''
                    }.png`)}
                  />
                </div>
              </div>
              <div className='column'>
                <div className='chart-title'>
                  Les destinations vers les 10 pays dont le nombre de vols a le
                  plus diminué{' '}
                </div>
                <div className='chart-header'>
                  Diminution des vols en jets privés entre l'été 2019 et 2021
                </div>
                <div className='chart-text less'>
                  de <b className='special less'>-64%</b> (Maroc) à{' '}
                  <b className='special less'>-25%</b> (Slovaquie)
                </div>
                <div className='mini-map-container'>
                  <div
                    className='map-label'
                    style={{
                      position: 'absolute',
                      left: '40%',
                      top: '37%',
                      width: '160px',
                      textAlign: 'left'
                    }}
                  >
                    Genève
                  </div>
                  <img
                    style={{ width: '100%' }}
                    src={require(`../../images/globe-jets-less${
                      darkMode ? '-dark' : ''
                    }.png`)}
                  />
                </div>
              </div>
            </div>
            <div className='ui text container'>
              <AutofitIFrame src='https://datawrapper.dwcdn.net/9SIQ8/' />
            </div>
          </div>
        </div>
      </div>

      <div className='ui vertical segment' style={{ paddingTop: 0 }}>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              «La crise sanitaire nous a apporté environ 40% de nouveaux clients
              qui ne voyageaient pas en jet privé, selon Adrien Fostoff,
              responsable marketing chez Albinati Aeronautics. C’est
              essentiellement en raison de la suppression de lignes commerciales
              et de craintes liées à la promiscuité dans l’aéroport, par exemple
              lors des contrôles de sécurité.»
            </p>
            <p>
              En effet, le terminal T3 de Cointrin, dédié à l’aviation
              d’affaires, dispose d’une douane dédiée où les passagers évitent
              les files d’attente. Un confort qui se paie cher: chez Albinati,
              un aller simple pour Londres coûte entre 8000 et 25’000 francs
              selon le type d’appareil choisi.
            </p>
            <p>
              D’après les statistiques de Genève Aéroport, les vols commerciaux
              non réguliers ont effectué 25’781 mouvements et transporté environ
              50’000 passagers en 2021. Soit un peu moins de deux passagers par
              vol en moyenne.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <h4>
              La Constitution genevoise prévoit une «limitation des nuisances»
            </h4>
            <p>
              En novembre 2019, la population genevoise a accepté l’initiative
              cantonale «Pour un pilotage démocratique de l’aéroport de Genève».
              Les initiants sont rassemblés au sein de la CARPE (Coordination
              régionale pour un aéroport de Genève urbain, respectueux de la
              population et de l’environnement), qui regroupe une quinzaine
              d’associations de riverains de l’aéroport et de défenseurs de
              l’environnement.
            </p>
            <p>
              Désormais inscrit dans la Constitution genevoise, le texte de
              l’initiative demande que le Canton tienne compte du «caractère
              urbain de l’aéroport» et «recherche un équilibre entre son
              importance pour la vie économique, sociale et culturelle et la
              limitation des nuisances pour la population et l’environnement»,
              dans les limites de ses compétences. En effet, l’aviation civile
              est du ressort de la Confédération. L’initiative doit encore être
              concrétisée par une modification de la loi sur l’Aéroport
              international de Genève (LAIG).
            </p>
          </div>
        </div>
      </div>

      <div
        className={`ui vertical segment ${darkMode ? 'inverted' : ''}`}
        style={{
          backgroundColor: '#91919122'
        }}
      >
        <div className='ui text container'>
          <div className='ta text'>
            <h4>Méthodologie</h4>
            <p>
              Nos données sont issues de la base de données du site web suédois{' '}
              <Link href=''>Flightradar24</Link>. Celui-ci affiche en temps réel
              les vols d'avions commerciaux et privés. FlightRadar nous a
              transmis tous les vols directs au départ et à l'arrivée de
              l'aéroport de Genève, du 1er janvier 2019 au 16 février 2022.
            </p>
            <p>
              Le trajet exact de chaque vol peut être visualisé grâce au
              transpondeur équipant les aéronefs. Toutefois, pour simplifier
              l'affichage des vols, nous avons croisé les informations de
              Flightradar24 avec une base de données contenant la localisation
              des principaux aéroports dans le monde.
            </p>
            <p>
              Les jets privés ont été identifiés manuellement grâce au code OACI
              qui désigne les appareils. Cet indicatif de type d'aéronef a
              ensuite été utilisé pour retrouver le modèle et le fabricant de
              chaque avion.
            </p>
            <p>
              Les données concernant les passagers proviennent des statistiques
              de Genève Aéroport.
            </p>
          </div>
        </div>
      </div>

      <Footer
        inverted={darkMode}
        hidePortfolioTeaser
        mailTo='interactif@tamedia.ch'
        locale='fr'
        articleId={ARTICLE_ID}
        credits={[
          ['Analyse des données', 'Paul Ronga et Mathieu Rudaz'],
          ['Texte', 'Titus Plattner et Paul Ronga'],
          ['Conception et réalisation', 'Mathieu Rudaz']
        ]}
      />
    </div>
  )
}
